import React from 'react';
import { captureFrontendException } from './sentry';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('VegAI UI error:', error, info?.componentStack);
    captureFrontendException(error, {
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-amber-50 px-6 py-10 text-slate-900">
          <div className="mx-auto max-w-lg rounded-2xl border border-amber-200 bg-white p-6 shadow-sm">
            <h1 className="text-xl font-bold text-emerald-800">Something went wrong</h1>
            <p className="mt-3 text-sm text-slate-600">
              The page hit an error while loading or rendering. Try a refresh. If this is Safari on iPhone, also try
              turning off experimental features or updating iOS — then reload.
            </p>
            <p className="mt-4 rounded-lg bg-slate-100 px-3 py-2 font-mono text-xs text-red-700 break-words">
              {String(this.state.error?.message || this.state.error)}
            </p>
            <button
              type="button"
              className="mt-5 w-full rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-semibold text-white shadow-sm hover:bg-emerald-700"
              onClick={() => window.location.reload()}
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
